import React from 'react';
import styled from 'styled-components';

interface ContainerBaseProps {
  children: React.ReactNode;
  backgroundColor?: string;
}

const ContainerMain = styled.div<{ backgroundColor?: string }>`
  display: flex;
  box-sizing: border-box;
  height: 100vh;
  width: 100vw;
  background-color: ${({ backgroundColor, theme }) =>
    backgroundColor || theme.colors.fundo};
`;

function ContainerBase({ children, backgroundColor }: ContainerBaseProps) {
  return (
    <ContainerMain backgroundColor={backgroundColor}>{children}</ContainerMain>
  );
}

export default ContainerBase;
